export const lightTheme = {
    tokens: {
        //General
        colorBackgroundLayoutMain: '#eee',
        colorTextAccent: '#e30613',
        colorTextHeadingDefault: '#e30613',
        //Side Navigation Toggle
        colorBackgroundLayoutToggleDefault: '#e30613',
        colorBackgroundLayoutToggleHover: '#eee',
        colorBackgroundLayoutToggleActive: '#383838',
        //Primary Button
        colorBackgroundButtonPrimaryDefault: '#e30613',
        colorTextButtonPrimaryDefault: 'white',
        colorBackgroundButtonPrimaryHover: '#383838',
        colorBackgroundButtonPrimaryActive: '#eee',
        colorTextButtonPrimaryActive: 'white',
        //NormalButton
        colorBorderButtonNormalDefault: '#e30613',
        colorTextButtonNormalDefault: '#e30613',
        colorBorderButtonNormalHover: '#383838',
        colorBackgroundButtonNormalHover: 'white',
        colorTextButtonNormalHover: '#383838',
        colorBorderButtonNormalActive: '#eee',
        colorTextButtonNormalActive: '#eee',
        colorBackgroundButtonNormalActive: '#e30613',
        colorBorderInputFocused: '#e30613',
        // Table
        colorItemSelected: '#e30613',
        colorBackgroundItemSelected: '#e306151b',
        // Checkbox
        colorBackgroundControlChecked: '#e30613',
        // Input
        
        colorBorderItemFocused: '#e30613',
    },
    contexts: {
        'top-navigation': {
            tokens: {
                //General
                colorTextAccent: '#383838',
                colorTextTopNavigationTitle: '#e30613',
                colorBackgroundContainerContent: '#eee',
                //Primary Button
                colorBackgroundButtonPrimaryDefault: '#e30613',
                colorBackgroundButtonPrimaryHover: '#383838',
                colorTextButtonPrimaryHover: 'white',
                colorTextButtonPrimaryDefault: 'white',
                colorBackgroundButtonPrimaryActive: '#e30613',
                colorTextButtonPrimaryActive: 'white',
                //Menu                
                colorTextInteractiveDefault: '#383838',
                colorTextInteractiveHover: '#e30613',
                colorBackgroundDropdownItemDefault: '#383838',             
            },
        },
        'header': {
            tokens: {
                //General
                colorTextAccent: '#e30613',
                colorTextLinkDefault: '#eee',
                colorTextLinkHover: '#e30613',
                colorBackgroundLayoutMain: '#383838',
                colorTextHeadingDefault: '#eee',
                colorTextHeadingSecondary: '#eee',
                colorTextBreadcrumbCurrent: '#e30613',
                colorTextBreadcrumbIcon: '#eee',
                //Primary Button
                colorBackgroundButtonPrimaryDefault: '#e30613',
                colorBackgroundButtonPrimaryHover: 'white',
                colorBackgroundButtonNormalDefault: '#383838',
                colorTextButtonPrimaryDefault: 'white',
                //Normal Button 
                colorTextButtonNormalDefault: 'white',
                colorBorderButtonNormalDefault: 'white',
                colorTextButtonNormalHover: '#e30613',
                colorBorderButtonNormalHover: '#e30613',  
           },
        },
    },
}

export const darkTheme = {
    tokens: {
        //General — Brand accents only; base dark styling comes from applyMode(Mode.Dark)
        colorTextAccent: '#e30613',
        colorTextHeadingDefault: '#e30613',
        //Side Navigation Toggle
        colorBackgroundLayoutToggleDefault: '#e30613',
        //Primary Button
        colorBackgroundButtonPrimaryDefault: '#e30613',
        colorTextButtonPrimaryDefault: 'white',
        colorBackgroundButtonPrimaryHover: '#383838',
        colorTextButtonPrimaryHover: 'white',
        colorBackgroundButtonPrimaryActive: '#e30613',
        colorTextButtonPrimaryActive: 'white',
        //Normal Button
        colorBorderButtonNormalDefault: '#e30613',
        colorTextButtonNormalDefault: '#e30613',
        colorBorderButtonNormalHover: '#383838',
        colorTextButtonNormalHover: '#383838',
        colorBorderButtonNormalActive: '#e30613',
        colorTextButtonNormalActive: 'white',
        colorBackgroundButtonNormalActive: '#e30613',
        //Links & Breadcrumbs
        colorTextLinkDefault: '#e30613',
        colorTextLinkHover: '#383838',
        colorTextInteractiveDefault: '#e30613',
        colorTextInteractiveHover: '#383838',
        colorTextBreadcrumbIcon: '#e30613',
        //Focus
        colorBorderInputFocused: '#e30613',
        colorBorderItemFocused: '#e30613',
        // Selection
        colorItemSelected: '#e30613',
        colorBackgroundItemSelected: '#e306131a',
        // Checkbox
        colorBackgroundControlChecked: '#e30613',
    },
    contexts: {
        'top-navigation': {
            tokens: {
                colorTextTopNavigationTitle: '#e30613',
                //Primary Button
                colorBackgroundButtonPrimaryDefault: '#e30613',
                colorBackgroundButtonPrimaryHover: '#383838',
                colorTextButtonPrimaryHover: 'white',
                colorTextButtonPrimaryDefault: 'white',
                colorBackgroundButtonPrimaryActive: '#e30613',
                colorTextButtonPrimaryActive: 'white',
                //Menu hover accent
                colorTextInteractiveHover: '#e30613',
            },
        },
        'header': {
            tokens: {
                colorTextAccent: '#e30613',
                colorTextLinkHover: '#e30613',
                colorTextBreadcrumbCurrent: '#e30613',
                //Primary Button
                colorBackgroundButtonPrimaryDefault: '#e30613',
                colorBackgroundButtonPrimaryHover: '#383838',
                colorTextButtonPrimaryHover: 'white',
                colorTextButtonPrimaryDefault: 'white',
                //Normal Button
                colorTextButtonNormalHover: '#e30613',
                colorBorderButtonNormalHover: '#e30613',
           },
        },
    },
}

export const theme = lightTheme;